import { CommaArrayParam } from 'helpers/CommaArrayParam';
import { useQueryParam, withDefault } from 'use-query-params';
import styles from './styles';
import {
  ATTR_NAME_MAPPING,
  ATTR_VALUE_MAPPING,
  DEFAULT_TEMPLATES,
  TEMPLATES,
} from './templates';

const findTemplate = (error, prevError) => {
  const template = TEMPLATES.find(
    (templ) =>
      templ.attrName === error.attr &&
      templ.operator === error.operator &&
      templ.isAggr === error.is_aggr &&
      (templ.attrName !== prevError?.attr ||
        templ.operator !== prevError?.operator ||
        templ.isAggr !== prevError?.is_aggr),
  );

  if (template) return template;

  const defaultTemplate = DEFAULT_TEMPLATES.find(
    (templ) => templ.isAggr === error.is_aggr,
  );

  return defaultTemplate;
};

const resolveValidationMessage = (error, prevError, handleClose) => {
  const template = findTemplate(error, prevError);
  if (!template) return null;

  if (error.operator === 'in') {
    const newValue = error.value
      .split(';')
      .map((v) => ATTR_VALUE_MAPPING[v] || v)
      .filter((v, pos, arr) => arr.findIndex((el) => el === v) === pos)
      .join(' / ');
    error.value = newValue;
  }

  const getGroupType = (groupType) => {
    switch (groupType) {
      case 'gpu_customisation':
        return 'GPU BACKPLATE';
      case 'cpu_cooling_system':
        return 'CPU COOLING SYSTEM';
      case 'gpu_cooling_type':
        return 'CPU COOLING SYSTEM';
      default:
        return groupType;
    }
  };

  const cpuCoolingTypeFix = (message) => {
    let newMess = message;
    if (
      message.props.children[4] === 'cpu_cooling_type' &&
      message.props.children[8] === 'water' &&
      message.props.children[1] === ' requires the '
    ) {
      let text1 = message.props.children[0];
      let updatedText1 = {
        ...text1,
        props: {
          ...text1.props,
          option: {
            ...text1.props.option,
            group_title: getGroupType(text1.props.option.group_type),
          },
        },
      };
      newMess = {
        ...message,
        props: {
          ...message.props,
          children: [
            'Your ',
            updatedText1,
            ' will require the ',
            message.props.children[2],
            ' to be water cooled.',
          ],
        },
      };
    }
    if (
      message.props.children[4] === 'cpu_cooling_type' &&
      message.props.children[8] === 'air' &&
      message.props.children[1] === ' requires the '
    ) {
      let text1 = message.props.children[0];
      let updatedText1 = {
        ...text1,
        props: {
          ...text1.props,
          option: {
            ...text1.props.option,
            group_title: getGroupType(text1.props.option.group_type),
          },
        },
      };
      newMess = {
        ...message,
        props: {
          ...message.props,
          children: [
            'Your ',
            updatedText1,
            ' will require the ',
            message.props.children[2],
            ' to be air cooled.',
          ],
        },
      };
    }

    if (
      message.props.children[4] === 'chassis_fans_size' &&
      message.props.children[8] === '120' &&
      message.props.children[1] === ' requires the '
    ) {
      let text1 = message.props.children[0];
      let updatedText1 = {
        ...text1,
        props: {
          ...text1.props,
          option: {
            ...text1.props.option,
            group_title: getGroupType(text1.props.option.group_type),
          },
        },
      };
      newMess = {
        ...message,
        props: {
          ...message.props,
          children: [
            updatedText1,
            ' requires 120mm ',
            message.props.children[2],
          ],
        },
      };
    }

    if (
      message.props.children[4] === 'gpu_cooling_type' &&
      message.props.children[8] === 'water' &&
      message.props.children[1] === ' requires the '
    ) {
      let text1 = message.props.children[0];
      let updatedText1 = {
        ...text1,
        props: {
          ...text1.props,
          option: {
            ...text1.props.option,
            group_title: getGroupType(text1.props.option.group_type),
          },
        },
      };
      newMess = {
        ...message,
        props: {
          ...message.props,
          children: [
            'Your open loop ',
            updatedText1,
            ' will require a compatible ',
            message.props.children[2],
          ],
        },
      };
    }
    return newMess;
  };

  const vars = {
    // It is the component that has the `req:` tag.
    // It requires something.
    from: (
      <ValidationMessageButton
        option={error.option}
        handleClose={handleClose}
      />
    ),
    // The component that needs to meet the condition.
    to: !error.is_aggr && (
      <ValidationMessageButton
        option={error.target}
        handleClose={handleClose}
      />
    ),
    attrName: ATTR_NAME_MAPPING[error.attr] || error.attr,
    attrValue: ATTR_VALUE_MAPPING[error.value] || error.value,
    operator: error.operator,
    isAggr: error.is_aggr,
  };

  const message = template.render(vars);
  let newMess = cpuCoolingTypeFix(message);
  return newMess;
};

const ValidationMessageButton = ({ option, handleClose }) => {
  const [, setCurrentStep] = useQueryParam('step');
  const [completed, setCompleted] = useQueryParam(
    'completed',
    withDefault(CommaArrayParam, []),
  );

  const handleChangeClick = (option) => {
    if (option.group_step_new === 'ultra-labs') {
      setCurrentStep('ultralabs');
    } else {
      setCurrentStep(option.group_step_new);
    }
    setCompleted(completed.filter((item) => item !== option.group_type));
    if (handleClose) {
      handleClose();
    }
    setTimeout(() => {
      document
        .getElementById(`group-type-${option.group_type}`)
        .scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
    }, 500);
  };

  return (
    <button type='button' onClick={() => handleChangeClick(option)}>
      {option.group_title}
      <style jsx>{styles}</style>
    </button>
  );
};

const ValidationMessage = ({ error, prevError, closeModal }) => (
  <div>
    {resolveValidationMessage(error, prevError, closeModal)}
    <style jsx>{styles}</style>
  </div>
);

export default ValidationMessage;
